import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { authwsEnvironment } from '../authws-environment';

/**
 * Get the Trimble ID migration status of a user
 * @param email email/username of the user
 * @returns user's migration status
 */
export function postMigrationStatus(this: unknown, email: string) {
  return fromFetch(
    new Request(authwsEnvironment.resolve(this).migrationStatusUrl, {
      method: 'POST',
      headers: {
        ...requiredHeaders,
      },
      body: JSON.stringify({ email }),
    })
  ).pipe(
    selectData(
      z.object({
        migrated: z.boolean(),
        exists: z.boolean(),
      })
    )
  );
}
